module.exports = __webpack_public_path__ + "img/ez-slot-ic-star-rank-animation.5e98fd7f.png";